// extracted by mini-css-extract-plugin
export default {"modalOverlay":"yD-z","modalContent":"zD-z","header":"AD-z","close":"BD-z"};